import React, { Component } from 'react';
import { Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import './AddTimeForm.css';
import FormInput from 'components/shared/form/FormInput';
import FormDropDown from 'components/shared/form/FormDropDown';
import FormDateTimePicker from 'components/shared/form/FormDateTimePicker';
import FormTimePicker from 'components/shared/form/FormTimePicker';

class AddTimeForm extends Component {
  render() {
    const edit = this.props.initialValues !== null;
    return (
      <div className="add-time-form">
        <Form horizontal onSubmit={this.props.handleSubmit}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Task
            </Col>
            <Col sm={9}>
              <Field
                component={FormDropDown}
                disabled={edit}
                name="taskId"
                options={this.props.tasks.map((task) => ({
                  value: task.id,
                  label: `${task.number} - ${task.name}`,
                }))}
                placeholder="Task"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Name/Title
            </Col>
            <Col sm={9}>
              <Field
                component={FormInput}
                name="name"
                placeholder="Name/Title"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Start Date
            </Col>
            <Col sm={9}>
              <Field
                component={FormDateTimePicker}
                name="startDate"
                placeholder="Start Date"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Time In
            </Col>
            <Col sm={9}>
              <Field
                component={FormTimePicker}
                name="timeIn"
                placeholder="Time In"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              Time Out
            </Col>
            <Col sm={9}>
              <Field
                component={FormTimePicker}
                name="timeOut"
                placeholder="Time Out"
              />
            </Col>
          </FormGroup>
          {this.props.invalid && this.props.submitFailed && (
            <div className="invalid-message">
              The outlined inputs should be added in order to add a time.
            </div>
          )}
          <FormGroup className="button-container">
            <Col sm={12}>
              <input
                className="btn button button-orange"
                type="submit"
                value={edit ? 'Update' : 'Create'}
              />
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  if (!values.taskId) {
    errors.taskId = 'Required';
  }
  if (!values.name) {
    errors.name = 'Required';
  }
  if (!values.startDate) {
    errors.startDate = 'Required';
  }
  if (!values.timeIn) {
    errors.timeIn = 'Required';
  }
  if (!values.timeOut) {
    errors.timeOut = 'Required';
  }
  return errors;
}

export default reduxForm({
  form: 'AddTimeForm',
  validate,
})(AddTimeForm);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/time/AddTimeForm.js